<ion-app [ngClass]="{'language-selection': showLanguageSelection}">
  <language-selection *ngIf="showLanguageSelection"></language-selection>
  <app-splash-screen (loaded)="onLoaded()" *ngIf="!loaded"></app-splash-screen>
  <ng-container *ngIf="loaded">
    <app-header></app-header>
    <div class="content">
      <ion-router-outlet></ion-router-outlet>
      <app-audio-player></app-audio-player>
    </div>
  </ng-container>
</ion-app>
